import { useCarValuationToolContext } from '../../CarValuationTool.context';
import { useOnSubmitValuation } from './hooks/OnSubmitValuation.hook';

import { Modal } from '../../../../../../../components/ToolkitV2/Modal/Modal';
import { ModalHeader } from '../../../../../../../components/ToolkitV2/Modal/subcomponents/ModalHeader';
import { ValueCarForm } from './components/ValueCarForm/ValueCarForm';
import { LoadingScreen } from './components/LoadingScreen/LoadingScreen';
import { ValuationDetails } from './components/ValuationDetails/ValuationDetails';
import { LookupError } from './components/LookupError/LookupError';

import { theme } from '../../../../../../../helpers/Theme';
import { Spacer } from '../../../../../../../helpers/genericStyles';

const ValueCarModal = () => {
  const {
    isValueCarModalOpen,
    carValuationData,
    isCarValuationPending,
    carValuationError,
    closeValueCarModal,
    isValuationArtificiallyLoading,
  } = useCarValuationToolContext();

  const { onSubmitCallback } = useOnSubmitValuation();

  const MODAL_NAME = 'Car Valuation Modal';

  const isLoading = isCarValuationPending || isValuationArtificiallyLoading;

  return (
    <Modal
      isOpen={isValueCarModalOpen}
      onRequestClose={closeValueCarModal}
      padding={`${theme.spacing.M24} ${theme.spacing.M16}`}
      paddingMedium={theme.spacing.L48}
      borderRadiusMedium={theme.borderRadius.default}
      height="100%"
      width="100%"
      widthMedium="640px"
      heightMedium="802px"
      contentLabel={MODAL_NAME}
      modalClassName="value-car"
    >
      <ModalHeader
        text="How much is your car worth right now?"
        weight="bold"
        size="L24"
        onRequestClose={closeValueCarModal}
        modalName={MODAL_NAME}
        color="GREY_DARKER"
      />
      <Spacer marginBottom="M24" />
      {!isLoading && !carValuationData && !carValuationError && (
        <ValueCarForm onSubmitCallback={onSubmitCallback} />
      )}
      {isLoading && <LoadingScreen />}
      {!isLoading && carValuationError && (
        <LookupError error={carValuationError} />
      )}
      {!isLoading && carValuationData && (
        <ValuationDetails carValuationData={carValuationData} />
      )}
    </Modal>
  );
};

export { ValueCarModal };
